// removed by extract-text-webpack-plugin
module.exports = {"sbTitle":"CategorySidebar__sbTitle___3LVuQ","categorySidebarList":"CategorySidebar__categorySidebarList___XmsVT","divide":"CategorySidebar__divide___3uEv-","categorySidebarListItem":"CategorySidebar__categorySidebarListItem___he1ra","categoryListItem":"CategorySidebar__categoryListItem___PgHSu","catagorySelectedItem":"CategorySidebar__catagorySelectedItem___3P40K"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/css/CategorySidebar.less
// module id = 78
// module chunks = 0 1